<template>
    <div class="sa-ft-timeline-container" :style="{ maxHeight: maxHeight + 'px' }">

        <div v-if="!items || items.length === 0" class="sa-ft-timeline-empty">
            <div class="sa-ft-empty-icon">📅</div>
            <p>Nessun appuntamento in programma</p>
        </div>

        <div v-else class="sa-ft-timeline-list">
            <div v-for="(item, index) in items" :key="index" class="sa-ft-timeline-item">
                <div class="sa-ft-timeline-indicator">
                    <div class="sa-ft-timeline-dot" :class="{ 'sa-ft-dot-active': index === 0 }"></div>
                    <div v-if="index !== items.length - 1" class="sa-ft-timeline-line"></div>
                </div>

                <div class="sa-ft-timeline-content">
                    <div class="sa-ft-timeline-header">
                        <span class="sa-ft-timeline-date">{{ item.data }}</span>
                        <span v-if="index === 0" class="sa-ft-badge-next">Prossimo</span>
                    </div>

                    <div class="sa-ft-timeline-card" :class="{ 'sa-ft-card-highlight': index === 0 }">
                        <span class="sa-ft-timeline-title">{{ item.prestazione }}</span>
                        <div class="sa-ft-timeline-meta">
                            <span class="sa-ft-meta-icon">👤</span>
                            <span class="sa-ft-timeline-subtitle">{{ item.medico }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SaFtTimeline',
    props: {
        // Array di oggetti: { data: '', prestazione: '', medico: '' }
        items: {
            type: Array,
            default: () => []
        },
        // Altezza massima del contenitore prima dello scroll
        maxHeight: {
            type: [String, Number],
            default: 600
        }
    }
}
</script>

<style scoped>
/* Container con scrollbar discreta */
.sa-ft-timeline-container {
    overflow-y: auto;

    padding: 8px;
    scrollbar-width: thin;
    scrollbar-color: #cbd5e1 transparent;
}

.sa-ft-timeline-container::-webkit-scrollbar {
    width: 5px;
}

.sa-ft-timeline-container::-webkit-scrollbar-thumb {
    background-color: #cbd5e1;
    border-radius: 10px;
}

/* Struttura Item */
.sa-ft-timeline-item {
    display: flex;
    gap: 16px;
}

/* Indicatore Visivo */
.sa-ft-timeline-indicator {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 14px;
    flex-shrink: 0;
}

.sa-ft-timeline-dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: #ffffff;
    border: 2px solid #cbd5e1;
    z-index: 2;
    margin-top: 4px;
    transition: all 0.3s ease;
}

/* Pallino evidenziato per il prossimo appuntamento */
.sa-ft-dot-active {
    background-color: var(--bg-sidebar);
    border-color: #ccfbf1;
    box-shadow: 0 0 0 4px rgba(0, 163, 255, 0.25);
}

.sa-ft-timeline-line {
    width: 2px;
    flex-grow: 1;
    background: #f1f5f9;
    margin: 4px 0;
}

/* Contenuto */
.sa-ft-timeline-content {
    flex-grow: 1;
    padding-bottom: 24px;
}

.sa-ft-timeline-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 6px;
}

.sa-ft-timeline-date {
    font-size: 11px;
    font-weight: 800;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.sa-ft-badge-next {
    font-size: 9px;
    background: var(--bg-sidebar);
    color: white;
    padding: 2px 8px;
    border-radius: 20px;
    font-weight: 700;
    text-transform: uppercase;
}

/* Card */
.sa-ft-timeline-card {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 12px;
    transition: all 0.2s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
}

/* Highlight primo appuntamento */
.sa-ft-card-highlight {
    background: #f0fdfa;
    border-color: var(--bg-sidebar);
}

.sa-ft-timeline-card:hover {
    transform: translateX(5px);
    border-color: var(--bg-sidebar);
    box-shadow: 0 4px 12px rgba(0, 163, 255, 0.25);
    cursor: pointer;
}

.sa-ft-timeline-title {
    display: block;
    font-size: 13px;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 4px;
}

.sa-ft-timeline-meta {
    display: flex;
    align-items: center;
    gap: 6px;
}

.sa-ft-meta-icon {
    font-size: 10px;
    opacity: 0.5;
}

.sa-ft-timeline-subtitle {
    font-size: 11px;
    color: #64748b;
    font-weight: 500;
}

/* Empty State */
.sa-ft-timeline-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 20px;
    color: #94a3b8;
    text-align: center;
}

.sa-ft-empty-icon {
    font-size: 32px;
    margin-bottom: 10px;
    filter: grayscale(1);
    opacity: 0.3;
}

.sa-ft-timeline-empty p {
    font-size: 13px;
    font-weight: 500;
    margin: 0;
}
</style>